import * as React from "react"

import { ReactComponent as PlaySvg } from 'resources/icons/track/play_solid.svg'

import * as st from './CustomerEngagement.styled.js'

const CustomerEngagement = () => (
  <st.Wrap
    color="blue"
    Icon={PlaySvg}
    isTopLine
  >
    <st.Content>
      <st.TitleWrap>
        <st.Title>
          Boost customer <ins>engagement</ins>
        </st.Title>
      </st.TitleWrap>
      <st.CustomerPortal>
        <st.Subheading>
          Customer facing portal
        </st.Subheading>
        <st.ScreensSection>
          <st.BrandingRow>
            <st.BrandingField>
              <img
                src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/branded.png"
                srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/branded.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/branded@2x.png 2x"
                width={59}
                height={38}
                alt="Branded customer portal"
              />
              <strong>Branded</strong>
            </st.BrandingField>
            <st.BrandingField>
              <img
                src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/white-labeled.png"
                srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/white-labeled.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/white-labeled@2x.png 2x"
                width={36}
                height={36}
                alt="White-labeled customer portal"
              />
              <strong>White-labeled</strong>
            </st.BrandingField>
          </st.BrandingRow>
          <st.Tiles>
              <img
                src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/schema.png"
                srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/schema.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/schema@2x.png 2x"
                width={248}
                height={160}
                alt="Color schemas of customer portal"
              />

              <img
                src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/dropzone.png"
                srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/dropzone.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/dropzone@2x.png 2x"
                width={94}
                height={94}
                alt="Upload logo"
              />

              <img
                src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/darkmode.png"
                srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/darkmode.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/darkmode@2x.png 2x"
                width={156}
                height={42}
                alt="Upload logo"
              />
          </st.Tiles>
        </st.ScreensSection>
        <st.Message>
          <p>Branded and white-labeled customer portal designed to be extremely clear for your customers, with easy-to-follow next steps, calls to action, and a project plan.</p>
          <p>Additionally, access to resources, team contacts, and chats provides the best customer experience and boosts engagement.</p>
        </st.Message>
      </st.CustomerPortal>
      <st.ImageOuterWrap>
      <st.ImageWrap>
        <st.MainImage
          src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/main.png"
          srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/main.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/main@2x.png 2x"
          width={1260}
          height={520}
          alt="Upload logo"
        />

        <st.CardImage
          src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/card.png"
          srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/card.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/card@2x.png 2x"
          width={643}
          height={143}
          alt="Next priority"
        />

        <st.LogoImage
          src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/logo.png"
          srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/logo.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/logo@2x.png 2x"
          width={86}
          height={46}
          alt="Logos"
        />

        <st.MenuImage
          src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/menu.png"
          srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/menu.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/menu@2x.png 2x"
          width={216}
          height={126}
          alt="Logos"
        />

        <st.HelpImage
          src="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/help.png"
          srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/help.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/index-portal/cfp/help@2x.png 2x"
          width={249}
          height={297}
          alt="Helpful resources"
        />
      </st.ImageWrap>
      </st.ImageOuterWrap>
    </st.Content>
  </st.Wrap>
)

export default CustomerEngagement
